export const COPY_KEY = 'freelancer_page.customer_protection_banner';
export const HREF =
    'https://help-pro.fiverr.com/hc/en-us/articles/21333583493649-Fiverr-Pro-satisfaction-guarantee-for-clients';

export const VIDEO_SRC =
    'https://fiverr-res.cloudinary.com/video/upload/v1/video-attachments/generic_asset/asset/19e22a9e911015e86da0e8612a67b3f9-1712849335405/guarantee_icon_for_gray';
